<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xiii">COSMOPOLITAN FILM CULTURES IN LATIN AMERICA, 1896–1960</a></p><a id="page_xiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm02.vue?22080c4c